import { Formatters } from '../modules'
import { FIELD_PAYMENT } from './_common'

export default {
  props: {
    state: {
      label: '状态',
      type: 'state',
      classes: 'collapsing hide-in-mobile',
    },
    date_start: {
      label: '开始日期',
      type: 'date',
      required: true,
      classes: 'hide-in-mobile',
    },
    date_end: {
      label: '结束日期',
      type: 'date',
      required: true,
      classes: 'hide-in-mobile',
    },
    date_delivery: {
      label: '交付日期',
      type: 'date',
      required: true,
    },
    duration_months: {
      label: '时长',
      type: 'number',
      formatter: Formatters.duration_months,
      required: true,
      classes: 'hide-in-mobile',
    },
    pay_unit_month: {
      label: '租金方式',
      type: 'number',
      formatter: Formatters.pay_unit_month,
      classes: 'hide-in-mobile',
    },
    price_month: {
      label: '租金 / 月',
      type: 'money',
      classes: 'right aligned hide-in-mobile',
    },
    earnest_money: {
      label: '定金',
      type: 'money',
      classes: 'right aligned positive hide-in-mobile',
    },
    refund_money: {
      label: '退款',
      type: 'money',
      classes: 'right aligned positive hide-in-mobile',
    },
    payment_method: FIELD_PAYMENT(),
    refund_method: FIELD_PAYMENT('退款方式'),
    customer_name: {
      label: '预定人',
    },
    customer_phone: {
      label: '预定人手机',
      type: 'phone',
    },
    note: {
      label: '备注',
      maxlength: 15,
      tooltip: true,
      classes: 'hide-in-mobile',
    },
    time_created: {
      label: '建立时间',
      type: 'time',
    },
  },
  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
    },
    order: {
      text: '签署合同',
      classes: 'blue',
    },
    cancel: {
      icon: 'remove',
      tooltip: '取消预订',
      classes: 'hide-in-mobile',
    },
  },
  layouts: {
    default: {
      layout: [
        'state',
        'customer_name',
        'customer_phone',
        'date_delivery',
      ],
    },
    detailed_table: {
      layout: [
        'state',
        'customer_name',
        'customer_phone',
        'date_start',
        'date_delivery',
        'duration_months',
        'pay_unit_month',
        'price_month',
        'earnest_money',
        'note',
      ],
    },
    detail: {
      layout: [
        'state',
        'date_start',
        'date_end',
        'date_delivery',
        'duration_months',
        'pay_unit_month',
        'price_month',
        'earnest_money',
        'refund_money',
        'payment_method',
        'refund_method',
        'customer_name',
        'customer_phone',
        'note',
        'time_created',
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/preorder.js